import axios from 'axios';
import { API_CONFIG } from '../config/config'; // Import the configuration

// Reusable error handler
const handleApiError = (error) => {
  if (error.response) {
    console.error('Error Response:', error.response.data);
  } else if (error.request) {
    console.error('Error Request:', error.request);
  } else {
    console.error('Error:', error.message);
  }
  throw error;
};

// Reusable POST request helper
const postRequest = async (url, data) => {
  try {
    const response = await axios.post(url, data, {
      headers: { 'Content-Type': 'application/json' },
      maxBodyLength: Infinity
    });
    console.log('Response:', JSON.stringify(response.data, null, 2));
    return response.data;
  } catch (error) {
    handleApiError(error);
  }
};

// Function to create employer profile
export const createEmployer = async (formData) => {
  const data = {
    name: formData.companyName,
    description: formData.description,
    phoneNumber: formData.phoneNumber,
    emailAddress: formData.emailAddress, // fixed casing
    location: formData.location
  };
  return await postRequest(`${API_CONFIG.endpoint}/api/Leads/createEmployeer`, data);
};

// Function to submit leads form data
export const createLeads = async (formData) => {
  const data = {
    name: formData.name,
    description: formData.message, // Assuming message corresponds to description
    phoneNumber: formData.phone,
    emailAddress: formData.email
  };
  return await postRequest(`${API_CONFIG.endpoint}/api/Leads`, data);
};

// Function to create employee profile
export const createEmployee = async (formData) => {
  const data = {
    firstName: formData.firstName,
    lastName: formData.lastName,
    gender: formData.gender,
    phoneNumber: formData.phoneNumber,
    emailAddress: formData.emailAddress,
    latitude: 0,
    longitude: 0, // fixed typo from lognitude
    education: formData.education,
    dateOfBirth: formData.dateOfBirth,
    active: "Y",
    aadhar: formData.aadhar,
    languages: formData.languages
  };
  return await postRequest(`${API_CONFIG.endpoint}/api/Leads/createEmployee`, data);
};

// Function to generate OTP
export const generateOtp = async (formData) => {
  const data = {
    mobileNumber: formData.mobileNumber,
    otpType: formData.otpType || "Registration",
    deviceId: formData.deviceId || "windows11",
    ipAddress: formData.ipAddress || "1.1.1.1"
  };

  try {
    const response = await postRequest(`${API_CONFIG.endpoint}/api/Leads/getotp`, data);
    
    // Optional: Return just the OTP value if needed
    return response.generate_otp;
    
  } catch (error) {
    // Error is already handled in postRequest
    throw error;
  }
};



export const validateOtp = async (formData) => {
  const data = {
    mobileNumber: formData.mobileNumber,
    otpCode: formData.otpCode,
    otpType: formData.otpType || "Registration",
    deviceId: formData.deviceId || "window11"
  };

  try {
    const response = await axios.post(`${API_CONFIG.endpoint}/api/Leads/verifyotp`, data, {
      headers: { 'Content-Type': 'application/json' }
    });

    // response.data contains
    // {
    //   is_verified: true/false,
    //   user_id: number,
    //   message: string
    // }
    return response.data;
  } catch (error) {
    if (error.response) {
      console.error('Error Response:', error.response.data);
    } else if (error.request) {
      console.error('Error Request:', error.request);
    } else {
      console.error('Error:', error.message);
    }
    throw error;
  }
};
